import { render, staticRenderFns } from "./groupVideosPage.vue?vue&type=template&id=2acf1245&"
import script from "./groupVideosPage.vue?vue&type=script&lang=js&"
export * from "./groupVideosPage.vue?vue&type=script&lang=js&"
import style0 from "./groupVideosPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports